'use strict';

const { h } = require('phy');
const { connect } = require('preact-redux');

const HeroTitle = require('../../coupons/views/hero-title');
const MainMenu = require('../../header/views/main-menu');
const LayoutServiceLinks = require('../../header/views/layout-service-links');
const AlertBar = require('../../../components/alert_bar');

function Header({
  keyAuthData,
  merchants,
  activePage,
  routes,
  isTouch,
  layoutServiceMenu,
  tag,
  blogUrl,
  alertAdvert,
  themedPage,
}) {
  return h('section', [
    h(LayoutServiceLinks, { layoutServiceMenu }),
    h(HeroTitle, { tag }),
    h(MainMenu, {
      keyAuthData,
      merchants,
      activePage,
      routes,
      isTouch,
      blogUrl,
      themedPage,
    }),
    h(AlertBar, { advert: alertAdvert }),
  ]);
}

const mapStateToProps = state => ({
  blogUrl: state.blogUrl,
  isTouch: state.isTouch,
  layoutServiceMenu: state.layoutServiceMenu,
  alertAdvert: state.alertAdvert,
  themedPage: state.themedPage,
});

module.exports = connect(mapStateToProps)(Header);
